import useAppStore from "store/app"

const useTranslation = () => {
  const t = useAppStore((state) => state.translations)

  return {
    fields: t?.data?.fields || {},
    pages: t?.data?.pages || {},
    anamnesis: t?.data?.anamnesis || {},
    messages: t?.data?.messages || {},
  }
}

export default useTranslation
